import { createContext, useContext } from "react"

const VersionContext = createContext<string | null>(null)

export function useIsOutdated() {
	const version = useContext(VersionContext)
	if (version === null) return false
	return version !== CONFIG.apiVersion
}

export default VersionContext
